import { buildLockedSuffix } from "./lockedSuffix";

/**
 * Heading suffix for the Set accrual ledger bulk action when some selected
 * transactions carry a live recognition schedule — see
 * partitionSelectionByScheduleLock.
 */
export function buildScheduleLockedSuffix(lockedCount: number): string {
    return buildLockedSuffix({
        lockedCount,
        reason: "with a recognition schedule",
    });
}
